import MenuEditorList from "./MenuEditorList";

export default class MenuElement {
  constructor(data) {
    Object.defineProperty(this, "type", {
      // not reactive // TODO :: think about
      get() {
        return this.allowedTypes[Number(!this.icon && this.children.count > 0)];
      },
      // eslint-disable-next-line no-unused-vars
      set(v) {},
      enumerable: true
    });
    for (let i in this.constructor.schema) {
      this[i] = this.constructor.schema[i].type(data[i]);
    }
  }

  static get schema() {
    return {
      uuid: {
        type: v => v || null,
        editable: false,
        raw: true
      },
      parent_uuid: {
        type: v => (v ? String(v, null) : null),
        editable: false,
        raw: true
      },
      icon: {
        type: v => String(v || "", null),
        editable: true,
        raw: true
      },
      title: {
        type: v => String(v || "", null),
        editable: true,
        raw: true
      },
      link: {
        type: v => String(v || "", null),
        editable: true,
        raw: true
      },
      type: {
        type: String,
        editable: false,
        raw: true
      },
      visible: {
        type: Boolean,
        editable: true,
        raw: true
      },
      disabled: {
        type: Boolean,
        editable: true,
        raw: true
      },
      sort: {
        type: Number,
        editable: false,
        raw: true
      },
      roles: {
        type: v => (v instanceof Array ? v : []),
        editable: true,
        raw: true
      },
      children: {
        type: v => new MenuEditorList(v),
        editable: false
      }
    };
  }

  get schema() {
    return this.constructor.schema;
  }

  static get allowedTypes() {
    return ["element", "group"];
  }

  get allowedTypes() {
    return this.constructor.allowedTypes;
  }

  static get allowedRoles() {
    return [];
  }

  get allowedRoles() {
    return this.constructor.allowedRoles;
  }

  getRawData() {
    let raw = {};
    this.children.parent_uuid = this.uuid;
    for (let v in this) {
      if (!this.schema[v].raw) {
        continue;
      }
      raw[v] = this[v];
    }
    this.children.parent_uuid = this.uuid;
    return [raw, ...this.children.getRawData()];
  }
}
